import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
  InsightDataItem,
} from '../InsightDataPayload';

export interface UserTypeData extends InsightDataItem {
  user_type: string;
  allocated_hours_in_range: number;
  actual_hours_in_range: number;
}

export interface CapacityManagementUserTypePayload
  extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_TYPE;
    id: string;
    attributes: {
      data: UserTypeData[];
    };
  };
}

export const parseCapacityManagementUserTypePayload = (
  payload: BaseInsightPayload
): CapacityManagementUserTypePayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_TYPE,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: UserTypeData[];
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_TYPE,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
